import axios from 'axios'

function Api () {
  return axios.create({
    baseURL: 'https://shuttle-tracker-api.aws.stthomas.edu/api/v1/'
  })
}

export default {
  getShuttles () {
    return Api().get('/shuttles')
      .then(response => response.data)
  },

  getShuttle (id) {
    return Api().get(`/shuttles/${id}`)
      .then(response => response.data)
  },

  getSchedule () {
    return Api().get('/schedule')
  }
}
